<template>
  <shop-list title="实体店管理" :type="1"></shop-list>
</template>

<script>

import ShopList from "@view/components/shop/shop-list.vue";

export default {
  name: "list",
  components: {ShopList},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
